exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".top-bar {\n    font-size: 16pt;\n    font-weight: normal;\n    color: #585D61;\n}\n\n.vertical-spacing{\n    margin-top: 20px;\n}\n\ntable\n{\n    font-size: 13px;\n    line-height: 24px;\n    table-layout: fixed;\n    margin-bottom: 10px;\n}\n\n.page {\n    width: 80%;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 100px;\n}\n\ntd:nth-child(2) {\n    width: 10%;\n    text-align: center;\n}\n\nhtml {\n    font-size: 14px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./styles/style.css
// module id = 7
// module chunks = 0